import React from 'react';
import YesRateBars from '@/components/globalPrompts/insights/charts/YesRateBars';
import { BooleanQuestionInsight } from '../insightsTypes';
import QuestionCardBarSection from './QuestionCardBarSection';

const BooleanQuestionCard: React.FC<{ insight: BooleanQuestionInsight }> = ({ insight }) => (
    <QuestionCardBarSection title="Yes rate by project">
        <YesRateBars
            rows={insight.perProject.map((project) => ({
                label: project.projectName,
                percentage: project.yesPct,
                responses: project.responses,
                yesCount: project.yesCount,
            }))}
        />
    </QuestionCardBarSection>
);

export default BooleanQuestionCard;
